import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { HomeService } from './services/home.service';
import { CountUpModule } from 'ngx-countup';
import { InViewportModule } from 'ng-in-viewport';
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    SharedModule,
    HomeRoutingModule,
    CountUpModule,
    InViewportModule,
    NgxSpinnerModule
  ],
  providers: [
    HomeService
  ]
})
export class HomeModule { }
